module.exports = __webpack_public_path__ + "static/media/Fish Games.3c45851b.svg";